import type { ServiceType } from '@rover/types';

export default function serviceTypeFactory(opts?: Partial<ServiceType>): ServiceType {
  return {
    accusativeObject: '',
    accusativeObjectSingular: '',
    action: '',
    alternativeRateUnit: '',
    alternativeRateUnitPlural: '',
    alternativeRateUnitTranslated: '',
    availabilityIsPerDog: false,
    browsable: false,
    description: '',
    displayName: '',
    endDateSelectorDescription: '',
    endTimeSelectorDescription: '',
    icon: '',
    isEndDateExclusive: false,
    location: '',
    name: '',
    numUnitsPerDayLabel: '',
    showNewLabel: false,
    slug: '',
    startDateSelectorDescription: '',
    startTimeSelectorDescription: '',
    suggestedPetType: 'any',
    supportsDayOfWeekSearch: false,
    supportsNonContiguousDates: false,
    supportsNumUnitsPerDay: false,
    supportsRecurringBilling: false,
    supportsRepeatBookings: false,
    supportsServiceDeliveryVerification: false,
    supportsStartEndDate: false,
    usesFlexibleTimeRanges: false,
    isDaytimeTraveling: false,
    visitDescription: '',
    ratePerPriceUnitLabel: '1',
    ...opts,
  };
}
